import type { ReactNode } from 'react';
import { SectionLabel } from '../portal';

interface SettingsRailCardProps {
  title: ReactNode;
  children: ReactNode;
}

/**
 * Explanatory side-rail card. Styles its body as 14/20 muted text and any
 * `<ul>` it is given as a bullet list, so pages pass plain markup.
 */
export function SettingsRailCard({ title, children }: SettingsRailCardProps) {
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-seeker-800 bg-seeker-900 p-6">
      <SectionLabel>{title}</SectionLabel>
      <div className="flex flex-col gap-3 text-sm leading-5 text-seeker-400 [&_ul]:flex [&_ul]:list-disc [&_ul]:flex-col [&_ul]:gap-2 [&_ul]:pl-4">
        {children}
      </div>
    </div>
  );
}
